module.exports = __webpack_public_path__ + "static/media/ic_excel.88936e67.svg";